import api from './api.service'

export const documentationTagConfigurationService = {
    list,
    get,
    save,
    update,
    _delete,
    importCSV
};

const BASE_URL = '/documentationTagConfigurations'

function list(max) {
    return api.get(BASE_URL, {max : max || 1000})
}

function get(id) {
    return api.get(BASE_URL + "/" + id)
}

function save(documentationTagConfiguration) {
    return api.post(BASE_URL, documentationTagConfiguration)
}

function update(id, documentationTagConfiguration) {
    return api.put(BASE_URL + "/" + id, documentationTagConfiguration)
}

function _delete(id) {
    return api.delete(BASE_URL + "/" + id)
}

function importCSV(data) {
	return api.post('/documentationTagConfiguration/importCSV', data)
}
